import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Application } from '../models/application';
import { CustomerDetails } from '../models/customer';
import { CustomersResponse } from '../models/customers';
import { ApplicationConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(private httpClient: HttpClient) {}

  getCustomers(queryString: string): Observable<CustomersResponse> {
    return this.httpClient.get<CustomersResponse>(
      ApplicationConfigService.config.apiUrl + '/api/portal/customers?' + queryString,
    );
  }

  postCustomer(customer: CustomerDetails): Observable<any> {
    const url = ApplicationConfigService.config.apiUrl + '/api/portal/customers';
    return this.httpClient.post<any>(url, customer);
  }

  getCustomer(customerId: string): Observable<CustomerDetails> {
    const url = ApplicationConfigService.config.apiUrl + '/api/portal/customers/' + customerId;

    return this.httpClient.get<CustomerDetails>(url);
  }

  putCustomer(customerId: string, customer: CustomerDetails): Observable<any> {
    const url = ApplicationConfigService.config.apiUrl + '/api/portal/customers/' + customerId;

    return this.httpClient.put(url, customer);
  }

  getCustomerApplications(customerId: string): Observable<Application[]> {
    const url = ApplicationConfigService.config.apiUrl + `/api/portal/customers/${customerId}/applications`;

    return this.httpClient.get<Application[]>(url);
  }
}
